import { Flex, Heading, LicencePlate, mdBumps, Typo } from '@wrisk/ui-components'
import { compact } from 'lodash-es'
import React, { FunctionComponent } from 'react'

import { getCoreAsset, Quote } from '../../../domain'
import {
  tDefaults,
  tProduct,
  useWriskTranslation,
} from '../../../infrastructure/internationalisation'

export interface QuoteHeaderProps {
  quote: Quote
}

export const QuoteHeader: FunctionComponent<QuoteHeaderProps> = ({ quote }) => {
  const { t } = useWriskTranslation()

  const asset = getCoreAsset(quote)
  const specification = asset.data['specification']
  const vehicleDescription = specification
    ? compact([specification.make, specification.model, specification.trim]).join(' ')
    : t(tDefaults('product', 'assetType'))

  return (
    <Flex
      p={mdBumps}
      flexDirection='column'
      justifyContent='flex-start'
      alignItems='flex-start'
    >
      <Typo mb={2}>{t(tProduct('name'))}</Typo>
      <Heading typoSize='lg' mb={[2, 3]}>
        {vehicleDescription}
      </Heading>
      <LicencePlate licencePlate={asset.data.vrn} />
    </Flex>
  )
}
